import $ from "jquery";
import slick from "slick-carousel";

function initCarousels() {
  var $breakpointSM = 576;
  var $breakpointMD = 768;
  var $breakpointLG = 992;
  var $breakpointXL = 1180;
  var $breakpointXXL = 1320;
  if (
    $(".js-gallery-slider").length &&
    !$(".js-gallery-slider").hasClass("slick-initialized")
  ) {
    $(".js-gallery-slider").slick({
      mobileFirst: false,
      infinite: false,
      autoplay: false,
      adaptiveHeight: true,
      draggable: true,
      swipe: true,
      fade: false,
      variableWidth: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      dotsClass: "carousel-pagination justify-content-sm-center",
      arrows: true,
      prevArrow:
        '<div class="carousel-button carousel-button-xxl-high carousel-button-prev"><svg class="svg-icon icon-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></div>',
      nextArrow:
        '<div class="carousel-button carousel-button-xxl-high carousel-button-next"><svg class="svg-icon icon-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></div>',
    });
  }

  if (
    $(".js-pricing-slider").length &&
    !$(".js-pricing-slider").hasClass("slick-initialized")
  ) {
    $(".js-pricing-slider").each(function () {
      $(this).slick({
        mobileFirst: true,
        infinite: false,
        autoplay: false,
        adaptiveHeight: true,
        draggable: true,
        swipe: true,
        fade: false,
        variableWidth: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        dotsClass: "carousel-pagination justify-content-sm-center",
        arrows: false,
        prevArrow:
          '<button type="button" class="btn btn-outline-secondary btn-icon carousel-button-prev"><svg class="svg-icon icon-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></button>',
        nextArrow:
          '<button type="button" class="btn btn-outline-secondary btn-icon carousel-button-next"><svg class="svg-icon icon-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></button>',
        responsive: [
          {
            breakpoint: $breakpointSM - 1,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: $breakpointLG - 1,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      });
    });
  }

  if (
    $(".js-nav-hor").length &&
    !$(".js-nav-hor").hasClass("slick-initialized")
  ) {
    $(".js-nav-hor").each(function () {
      $(this).slick({
        mobileFirst: true,
        infinite: false,
        autoplay: false,
        adaptiveHeight: true,
        draggable: true,
        swipe: true,
        fade: false,
        variableWidth: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: false,
        dotsClass: "carousel-pagination justify-content-center",
        arrows: true,
        prevArrow: '<button class="nav-link-arrow nav-link-arrow-prev" type="button"><svg class="svg-icon icon-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-angle"></use></svg></button>',
        nextArrow: '<button class="nav-link-arrow nav-link-arrow-next" type="button"><svg class="svg-icon icon-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-angle"></use></svg></button>',
        responsive: [
          {
            breakpoint: $breakpointSM - 1,
            settings: {
              slidesToShow: 5,
            },
          },
          {
            breakpoint: $breakpointLG - 1,
            settings: {
              slidesToShow: 7,
            },
          },
        ],
      });
    });
  }

  if (
    $(".js-card-slider-3").length &&
    !$(".js-card-slider-3").hasClass("slick-initialized")
  ) {
    $(".js-card-slider-3").each(function () {
      if ($(this)) {
        $(this).slick({
          mobileFirst: true,
          infinite: false,
          autoplay: false,
          adaptiveHeight: true,
          draggable: true,
          swipe: true,
          fade: false,
          variableWidth: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          dotsClass: "carousel-pagination justify-content-sm-center",
          arrows: true,
          prevArrow:
            '<button type="button" class="btn btn-outline-secondary btn-icon carousel-button-prev"><svg class="svg-icon icon-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></button>',
          nextArrow:
            '<button type="button" class="btn btn-outline-secondary btn-icon carousel-button-next"><svg class="svg-icon icon-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></button>',
          appendArrows: $(this).closest(".carousel").find(".carousel-controls"),
          //appendArrows: $( '.carousel-controls' ),
          responsive: [
            {
              breakpoint: $breakpointSM - 1,
              settings: {
                slidesToShow: 2,
                variableWidth: false,
              },
            },
            {
              breakpoint: $breakpointMD - 1,
              settings: {
                slidesToShow: 3,
                variableWidth: false,
              },
            },
          ],
        });
      }
    });
  }

  if (
    $(".js-card-slider-4").length &&
    !$(".js-card-slider-4").hasClass("slick-initialized")
  ) {
    $(".js-card-slider-4").each(function () {
      if ($(this)) {
        $(this).slick({
          mobileFirst: true,
          infinite: false,
          autoplay: false,
          adaptiveHeight: true,
          draggable: true,
          swipe: true,
          fade: false,
          variableWidth: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          dotsClass: "carousel-pagination justify-content-sm-center",
          arrows: true,
          prevArrow:
            '<button type="button" class="btn btn-outline-secondary btn-icon carousel-button-prev"><svg class="svg-icon icon-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></button>',
          nextArrow:
            '<button type="button" class="btn btn-outline-secondary btn-icon carousel-button-next"><svg class="svg-icon icon-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></button>',
          appendArrows: $(this).closest(".carousel").find(".carousel-controls"),
          //appendArrows: $( '.carousel-controls' ),
          responsive: [
            {
              breakpoint: $breakpointSM - 1,
              settings: {
                slidesToShow: 2,
                variableWidth: false,
              },
            },
            {
              breakpoint: $breakpointMD - 1,
              settings: {
                slidesToShow: 3,
                variableWidth: false,
              },
            },
            {
              breakpoint: $breakpointLG - 1,
              settings: {
                slidesToShow: 4,
                variableWidth: false,
              },
            },
          ],
        });
      }
    });
  }

  if (
    $(".js-card-slider-5").length &&
    !$(".js-card-slider-5").hasClass("slick-initialized")
  ) {
    $(".js-card-slider-5").each(function () {
      if ($(this)) {
        $(this).slick({
          mobileFirst: true,
          infinite: false,
          autoplay: false,
          adaptiveHeight: true,
          draggable: true,
          swipe: true,
          fade: false,
          variableWidth: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          dotsClass: "carousel-pagination justify-content-sm-center",
          arrows: true,
          prevArrow:
            '<button type="button" class="btn btn-outline-secondary btn-icon carousel-button-prev"><svg class="svg-icon icon-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></button>',
          nextArrow:
            '<button type="button" class="btn btn-outline-secondary btn-icon carousel-button-next"><svg class="svg-icon icon-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></button>',
          appendArrows: $(this).closest(".carousel").find(".carousel-controls"),
          //appendArrows: $( '.carousel-controls' ),
          responsive: [
            {
              breakpoint: $breakpointSM - 1,
              settings: {
                slidesToShow: 2,
                variableWidth: false,
              },
            },
            {
              breakpoint: $breakpointMD - 1,
              settings: {
                slidesToShow: 3,
                variableWidth: false,
              },
            },
            {
              breakpoint: $breakpointLG - 1,
              settings: {
                slidesToShow: 4,
                variableWidth: false,
              },
            },
            {
              breakpoint: $breakpointXL - 1,
              settings: {
                slidesToShow: 5,
                variableWidth: false,
              },
            },
          ],
        });
      }
    });
  }

  if (
    $(".js-card-slider-reset").length &&
    !$(".js-card-slider-reset").hasClass("slick-initialized")
  ) {
    $(".js-card-slider-reset").each(function () {
      $(this).slick({
        mobileFirst: true,
        infinite: false,
        autoplay: false,
        adaptiveHeight: true,
        draggable: true,
        swipe: true,
        fade: false,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        dotsClass: "carousel-pagination justify-content-sm-center",
        arrows: true,
        prevArrow:
          '<button type="button" class="btn btn-outline-secondary btn-icon carousel-button-prev"><svg class="svg-icon icon-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></button>',
        nextArrow:
          '<button type="button" class="btn btn-outline-secondary btn-icon carousel-button-next"><svg class="svg-icon icon-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></button>',
        appendArrows: $(this).closest(".carousel").find(".carousel-controls"),
        //appendArrows: $( '.carousel-controls' ),
        responsive: [
          {
            breakpoint: $breakpointSM - 1,
            settings: {
              slidesToShow: 2,
              variableWidth: false,
            },
          },
          {
            breakpoint: $breakpointMD - 1,
            settings: "unslick",
          },
        ],
      });
    });
  }

  if ($(".js-timer-slider-with-bg").length) {
    $(".js-timer-slider-with-bg").each(function () {
      var $thisSlider = $(this);

      if (!$thisSlider.hasClass("slick-initialized")) {
        var $associatedBgSlider = $thisSlider
          .closest(".block")
          .find(".js-background-slider");

        $thisSlider.slick({
          infinite: true,
          autoplay: false,
          speed: 500,
          adaptiveHeight: true,
          fade: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          asNavFor: $associatedBgSlider,
        });

        if (
          $associatedBgSlider.length &&
          !$associatedBgSlider.hasClass("slick-initialized")
        ) {
          $associatedBgSlider.slick({
            infinite: true,
            autoplay: false,
            speed: 500,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            asNavFor: $thisSlider,
          });
        }

        // timer pagination
        var time = 10000;
        var percentTime;
        var tick;
        var progressBarIndex = 0;

        $thisSlider
          .closest(".block")
          .find(".timer-pagination .timer-pagination-bar")
          .each(function (index) {
            var progress =
              '<div class="inProgress inProgress' + index + '"></div>';
            $(this).html(progress);
          });

        function startProgressbar() {
          resetProgressbar();
          percentTime = 0;
          tick = setInterval(function () {
            percentTime += 1 / (time / 1000);
            $thisSlider
              .closest(".block")
              .find(".inProgress" + progressBarIndex)
              .css({
                width: percentTime + "%",
              });
            if (percentTime >= 100) {
              progressBarIndex++;
              if (
                progressBarIndex >= $thisSlider.slick("getSlick").slideCount
              ) {
                progressBarIndex = 0;
              }
              $thisSlider.slick("slickNext");
              startProgressbar();
            }
          }, 10);
        }

        function interval() {
          if (
            $thisSlider
              .find(
                '.slick-track div[data-slick-index="' + progressBarIndex + '"]'
              )
              .attr("aria-hidden") === "true"
          ) {
            progressBarIndex = $thisSlider
              .find('.slick-track div[aria-hidden="false"]')
              .data("slickIndex");
            startProgressbar();
          } else {
            percentTime += 1 / (time / 1000);
            $(".inProgress" + progressBarIndex).css({
              width: percentTime + "%",
            });
            if (percentTime >= 100) {
              $thisSlider.slick("slickNext");
              progressBarIndex++;
              if (progressBarIndex > 2) {
                progressBarIndex = 0;
              }
              startProgressbar();
            }
          }
        }

        function resetProgressbar() {
          $thisSlider
            .closest(".block")
            .find(".inProgress")
            .css({
              width: 0 + "%",
            });
          clearInterval(tick);
        }

        startProgressbar();

        $thisSlider
          .closest(".block")
          .find(".timer-pagination .timer-pagination-item")
          .click(function () {
            clearInterval(tick);

            // Get the slide index that user wants to navigate to
            var goToThisIndex = $(this).find(".timer-pagination-bar").data("slickIndex");

            // Update the progressBarIndex to the clicked index
            progressBarIndex = goToThisIndex;

            $thisSlider.slick("slickGoTo", goToThisIndex, false);
            startProgressbar();
          });
      }
    });

  }

  if ($(".js-timer-slider").length) {
    $(".js-timer-slider").each(function () {
      var $thisSlider = $(this);

      if (!$thisSlider.hasClass("slick-initialized")) {

        $thisSlider.slick({
          infinite: true,
          autoplay: false,
          speed: 500,
          adaptiveHeight: true,
          fade: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
        });

        // timer pagination
        var time = 10000;
        var percentTime;
        var tick;
        var progressBarIndex = 0;

        $thisSlider
          .closest(".block")
          .find(".timer-pagination .timer-pagination-bar")
          .each(function (index) {
            var progress =
              '<div class="inProgress inProgress' + index + '"></div>';
            $(this).html(progress);
          });

        function startProgressbar() {
          resetProgressbar();
          percentTime = 0;
          tick = setInterval(function () {
            percentTime += 1 / (time / 1000);
            $thisSlider
              .closest(".block")
              .find(".inProgress" + progressBarIndex)
              .css({
                width: percentTime + "%",
              });
            if (percentTime >= 100) {
              progressBarIndex++;
              if (
                progressBarIndex >= $thisSlider.slick("getSlick").slideCount
              ) {
                progressBarIndex = 0;
              }
              $thisSlider.slick("slickNext");
              startProgressbar();
            }
          }, 10);
        }

        function interval() {
          if (
            $thisSlider
              .find(
                '.slick-track div[data-slick-index="' + progressBarIndex + '"]'
              )
              .attr("aria-hidden") === "true"
          ) {
            progressBarIndex = $thisSlider
              .find('.slick-track div[aria-hidden="false"]')
              .data("slickIndex");
            startProgressbar();
          } else {
            percentTime += 1 / (time / 1000);
            $(".inProgress" + progressBarIndex).css({
              width: percentTime + "%",
            });
            if (percentTime >= 100) {
              $thisSlider.slick("slickNext");
              progressBarIndex++;
              if (progressBarIndex > 2) {
                progressBarIndex = 0;
              }
              startProgressbar();
            }
          }
        }

        function resetProgressbar() {
          $thisSlider
            .closest(".block")
            .find(".inProgress")
            .css({
              width: 0 + "%",
            });
          clearInterval(tick);
        }

        startProgressbar();

        $thisSlider
          .closest(".block")
          .find(".timer-pagination .timer-pagination-item")
          .click(function () {
            clearInterval(tick);

            // Get the slide index that user wants to navigate to
            var goToThisIndex = $(this).find(".timer-pagination-bar").data("slickIndex");

            // Update the progressBarIndex to the clicked index
            progressBarIndex = goToThisIndex;

            $thisSlider.slick("slickGoTo", goToThisIndex, false);
            startProgressbar();
          });
      }
    });

  }

  if (
    $(".js-logos-slider").length &&
    !$(".js-logos-slider").hasClass("slick-initialized")
  ) {
    $(document).ready(function () {
      $(".js-logos-slider").each(function () {
        $(this).slick({
          speed: 6000,
          autoplaySpeed: 0,
          cssEase: 'linear',
          mobileFirst: true,
          infinite: true,
          autoplay: true,
          adaptiveHeight: false,
          draggable: true,
          swipe: true,
          fade: false,
          variableWidth: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
        });
      });
    });
  }

  if (
    $(".js-logos-slider-alt").length &&
    !$(".js-logos-slider-alt").hasClass("slick-initialized")
  ) {
    $(".js-logos-slider-alt").each(function () {
      $(this).slick({
        speed: 6000,
        autoplaySpeed: 0,
        cssEase: 'linear',
        mobileFirst: true,
        infinite: true,
        autoplay: true,
        adaptiveHeight: false,
        draggable: true,
        swipe: true,
        fade: false,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: $breakpointXL - 1,
            settings: {
              slidesToShow: 6,
              variableWidth: false,
            },
          },
        ],
      });
    });
  }

  if (
    $(".js-card-slider-reset").length &&
    !$(".js-card-slider-reset").hasClass("slick-initialized")
  ) {
    $(".js-card-slider-reset").each(function () {
      $(this).slick({
        mobileFirst: true,
        infinite: false,
        autoplay: false,
        adaptiveHeight: true,
        draggable: true,
        swipe: true,
        fade: false,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        dotsClass: "carousel-pagination justify-content-sm-center",
        arrows: true,
        prevArrow:
          '<button type="button" class="btn btn-outline-secondary btn-icon carousel-button-prev"><svg class="svg-icon icon-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></button>',
        nextArrow:
          '<button type="button" class="btn btn-outline-secondary btn-icon carousel-button-next"><svg class="svg-icon icon-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/veronapharma/assets/sprite/icons.svg#icon-chevron"></use></svg></button>',
        appendArrows: $(this).closest(".carousel").find(".carousel-controls"),
        //appendArrows: $( '.carousel-controls' ),
        responsive: [
          {
            breakpoint: $breakpointSM - 1,
            settings: {
              slidesToShow: 2,
              variableWidth: false,
            },
          },
          {
            breakpoint: $breakpointMD - 1,
            settings: "unslick",
          },
        ],
      });
    });
  }
}
$(document).ready(function () {
  initCarousels();
});

(function () {
  if (typeof wp === "undefined") {
    return;
  }

  if (typeof wp?.data !== "undefined") {
    wp?.data.subscribe(() => {
      initCarousels();
    });
  }
})();
